import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { reduxForm } from 'redux-form';

const ModalForm = (props) => {
  const { isOpen, title, formBuilder } = props;

  return (
    <Modal isOpen={isOpen} className="modal-form">
      <ModalHeader className="header">
        <span className="title">{title}</span>
      </ModalHeader>
      <ModalBody>{formBuilder}</ModalBody>
    </Modal>
  );
};

ModalForm.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  formBuilder: PropTypes.shape(PropTypes.shape).isRequired,
};

export default reduxForm({
  form: 'ModalForm',
})(withTranslation('common')(ModalForm));
